import React from 'react';
import { fetchVerifiers } from '../login/api.actions';
import { connect } from 'react-redux';
import history from '../history';
import {FormattedMessage} from "react-intl";

class VerifierSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      verifiers: ''
    };

    this.goToValidator = this.goToValidator.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(fetchVerifiers()).then(( {response} ) => {
      if (response) {
        this.setState({ verifiers: response });
        if (response.length === 1) {
          this.goToValidator(response[0]);
        } else if (response.length === 0) {
          history.push('/');
        }
      } else {
        history.push('/');
      }
    });
  }

  goToValidator(verifier) {
    sessionStorage.setItem('verifier', JSON.stringify(verifier));
    sessionStorage.setItem('currentConfiguration', JSON.stringify(verifier));
    sessionStorage.setItem('id_pos', verifier.pointOfSaleId);

    history.push('/validator');
  }

  render() {
    const { verifiers } = this.state;

    return verifiers ? (
      <div className="verifierSelection">
        <h2><FormattedMessage defaultMessage="Selecciona un validador" id="title.select.verifier"/></h2>
        <ul>
          {verifiers.map((verifier, index) => (
            <li key={index} onClick={() => this.goToValidator(verifier)}>
              {verifier.verifierId} - {verifier.name}
            </li>
          ))}
        </ul>
      </div>
    ) : (
      <div>Loading...</div>
    );
  }
}

export default connect()(VerifierSelection);
